import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TrackJS } from 'trackjs';

import Actions from '../../action';
import PanelLoading from '../../component/panel/loading';

export class PanelErrorBoundary extends React.PureComponent {
  state = {
    error: null,
  };

  componentDidCatch(error) {
    this.setState({ error });
    this.props.setNotification('error', 'something_went_wrong');
    TrackJS.track(error);
  }

  render() {
    const { error } = this.state;

    if (!error) return this.props.children;

    return <PanelLoading />;
  }
}

PanelErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  setNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setNotification: Actions.Notification.setNotification,
};

export default connect(
  null,
  mapDispatchToProps
)(PanelErrorBoundary);
